import { useEffect } from 'react';

declare global {
  interface Window {
    Beacon: any;
  }
}

export const useHelpScoutBeacon = () => {
  useEffect(() => {
    if (!window.Beacon) {
      window.Beacon = function (method: string, options?: any, data?: any) {
        window.Beacon.readyQueue.push({ method, options, data });
      };
      window.Beacon.readyQueue = [];

      const loadBeacon = () => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://beacon-v2.helpscout.net';
        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode!.insertBefore(script, firstScript);
      };

      if (document.readyState === 'complete') {
        loadBeacon();
      } else {
        window.addEventListener('load', loadBeacon, false);
      }
    }

    window.Beacon('init', 'e529144e-75a1-48ee-b394-533fdecc3d59');
  }, []);

  return null; // This component only adds the script, so it renders nothing
};
